module.exports = __webpack_public_path__ + "img/aizhinengzhushou.63b076d8.png";